module.exports = __webpack_public_path__ + "assets/ZS排行2.6f44b106.svg";